import { SvgIcon } from '@mui/material'

const ArrowRightToLine = (props) => {
  return (
    <SvgIcon viewBox='-2 0 19 16' {...props}>
      <path
        d='M17 1.75C17.5528 1.75 18 2.19719 18 2.75V12.75C18 13.3028 17.5528 13.75 17 13.75C16.4472 13.75 16 13.3028 16 12.75V2.75C16 2.19719 16.4472 1.75 17 1.75Z'
        className='secondary'
      />
      <path d='M9.62366 12.7903C9.23303 13.1809 8.60022 13.1809 8.20959 12.7903C7.81897 12.3997 7.81897 11.7685 8.21022 11.3772L10.5033 9.08409H4.91578C4.36297 9.08409 3.91578 8.63691 3.91578 8.08409C3.91578 7.53128 4.36297 7.08409 4.91578 7.08409H10.5002L8.20881 4.79097C8.0135 4.59597 7.91578 4.34028 7.91578 4.08409C7.91578 3.82784 8.01272 3.57162 8.20959 3.37628C8.60022 2.98566 9.23303 2.98566 9.62366 3.37628L13.6237 7.37628C14.0143 7.76691 14.0143 8.39972 13.6237 8.79034L9.62366 12.7903Z' />
    </SvgIcon>
  )
}

export default ArrowRightToLine
